{
  "/": {
    "title": "Yacht Management & Boat Maintenance Software | YachtApp",
    "description": "Manage boat maintenance, service records, inventory and crew tasks in one place. Explore YachtApp for private owners and charter fleets.",
    "indexable": true
  },
  "/about": {
    "title": "About YachtApp | Boat & Charter Management Software",
    "description": "Learn how YachtApp helps boat owners and charter teams organize maintenance, vessel records and daily operations. Meet the company behind the platform.",
    "indexable": true
  },
  "/how-it-works": {
    "title": "How YachtApp Works | Boat Setup & Daily Operations",
    "description": "Set up your boats, organize maintenance, assign tasks and keep service records with YachtApp. Follow the workflow from setup to daily use.",
    "indexable": true
  },
  "/features": {
    "title": "Yacht Management Features | Maintenance, Logs & Crew | YachtApp",
    "description": "Explore YachtApp features for boat maintenance, service logs, inventory, documents, checklists and crew coordination across your vessels.",
    "indexable": true
  },
  "/why-yachtapp": {
    "title": "Why YachtApp | Connected Yacht Operations",
    "description": "Discover how YachtApp connects maintenance, crew coordination, checklists and vessel records to help owners and operators replace disconnected workflows.",
    "indexable": true
  },
  "/yachtapp-solutions": {
    "title": "Yacht Operations for Owners & Crews | YachtApp",
    "description": "Explore YachtApp workflows for yacht owners, captains and operational crews: maintenance planning, voyage records, checklists and fleet visibility.",
    "indexable": true
  },
  "/smart-yacht-management": {
    "title": "Smart Yacht Management | Voyages & Tasks | YachtApp",
    "description": "Organize yacht voyages, maintenance, documents and onboard tasks in one workspace. Explore connected workflows for captains, crews and fleet owners.",
    "indexable": true
  },
  "/overview": {
    "title": "YachtApp Overview | Vessel Management Workspace",
    "description": "Get an overview of YachtApp for organizing vessel maintenance, voyage records and crew tasks. Explore the platform and compare available plans.",
    "indexable": true
  },
  "/crewfinder-details": {
    "title": "CrewFinder | Yacht Crew Marketplace",
    "description": "Explore CrewFinder for yacht owners, skippers and sailors. Discover how profiles, crew opportunities and invitations help connect people for onboard roles.",
    "indexable": true
  },
  "/contact": {
    "title": "Contact YachtApp | Demos & Support",
    "description": "Contact YachtApp for product questions, a walkthrough or help with your account. Talk to our team about software for your boats and charter fleet.",
    "indexable": true
  },
  "/subscriptions": {
    "title": "YachtApp Pricing | Boat & Fleet Subscription Plans",
    "description": "Compare YachtApp subscription plans for boat owners and growing fleets. Review vessel limits, included features, billing periods and the 30-day free trial.",
    "indexable": true
  },
  "/privacy-policy": {
    "title": "Privacy Policy | YachtApp",
    "description": "Read the YachtApp privacy policy to learn how personal information is collected, used and protected, and how to contact us about your privacy rights.",
    "indexable": true
  },
  "/terms-and-conditions": {
    "title": "Terms and Conditions | YachtApp",
    "description": "Read the terms and conditions for using YachtApp, including account responsibilities, subscriptions and use of the yacht management platform.",
    "indexable": true
  },
  "/login": {
    "title": "Sign In | YachtApp",
    "description": "Sign in to your YachtApp account to manage your vessels and tasks.",
    "indexable": false
  },
  "/register": {
    "title": "Create Your Account | YachtApp",
    "description": "Create your YachtApp account to organize your boats, maintenance and vessel records.",
    "indexable": false
  },
  "/reset-password": {
    "title": "Reset Your Password | YachtApp",
    "description": "Request a password reset for your YachtApp account.",
    "indexable": false
  },
  "/verify-email": {
    "title": "Verify Your Email | YachtApp",
    "description": "Verify the email address associated with your YachtApp account.",
    "indexable": false,
    "prerender": false
  },
  "/unauthorized": {
    "title": "Access Denied | YachtApp",
    "description": "This YachtApp page requires additional access permissions.",
    "indexable": false
  }
}
